module.exports = __webpack_public_path__ + "assets/img/activity-time-36eb49b5.png";